import Vue from "vue";
let currentRequest = 0;

const AttachmentTypeService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("file_type", id, {});
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START ATTACHMENT_TYPE `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "file_type",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] ATTACHMENT_TYPE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END ATTACHMENT_TYPE `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { AttachmentTypeService };
